module.exports = __webpack_public_path__ + "img/image-easy-to-use.0f592c89.png";